<main id="main-content" tabindex="-1" aria-label="Impact Videos">
  <div class="px-20">
    @if (canAdd) {
        <div class="md:flex md:flex-row justify-end mt-4">
        <prism-btn
          btnClass="md:mt-2 bg-white text-dark-purple font-bold border-2 p-0 m-0 rounded-xl border-dark-purple"
          (click)="goToResourcesForm()">
        <i class="uil uil-plus text-dark-purple font-bold pr-1"></i
          >Add Video
      </prism-btn>
    </div>
      }
    <div id="body" class="my-4 content-contain-impact">
      <prism-title title="Impact Videos" additionalClasses="text-4xl"></prism-title>

      <p class="mb-[30px]">This is just a placeholder. This page contains resources that we endorse that are sourced
          from other institutions. This is not a part of the CaPSPD system.<br>These resources may
          come with fees.
      </p>
        <prism-card-list
          [dataList]="impactVideoList"
          [listName]="'impact'"
          (cardClick)="viewImpactVideo($event)">
        </prism-card-list>
    </div>
  </div>
</main>